module.exports = __webpack_public_path__ + "static/media/1_.858a0c5c.jpeg";